import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface AdminUser {
  id: string
  email: string
  name: string | null
  role: 'super_admin' | 'admin'
}

interface AuthState {
  user: AdminUser | null
  token: string | null
  isAdmin: boolean
  setAuth: (user: AdminUser, token: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAdmin: false,
      setAuth: (user, token) => set({ user, token, isAdmin: true }),
      logout: () => set({ user: null, token: null, isAdmin: false }),
    }),
    {
      name: 'alertwhale-admin-auth',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
